import { useContext, useEffect } from "react";
import { UserContext } from "../context/UserContext";
import { useModal } from "../context/ModalContext";
import { useLocation, useNavigate } from "react-router-dom";
import { isAnamnesePreviewNavigation } from "../anamnese-v2/utils/previewSession";
import { setRedirectAfterLogin } from "../utils/redirectAfterLogin";
import Spinner from "./Spinner";

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loadingAuth } = useContext(UserContext);
  const { openModal } = useModal();
  const navigate = useNavigate();
  const location = useLocation();
  const isPreviewNav = isAnamnesePreviewNavigation(location);

  useEffect(() => {
    if (isPreviewNav) {
      return;
    }
    if (!loadingAuth && !isAuthenticated) {
      try {
        const current = window.location.pathname + window.location.search;
        setRedirectAfterLogin(current || "/minha-conta/dashboard");
      } catch {}
      openModal("modalLogin", {
        fromPrivateRoute: true,
        onClose: () => {
          navigate("/", { replace: true });
        },
      });
    }
  }, [loadingAuth, isAuthenticated, openModal, location.pathname, location.search, isPreviewNav, navigate]);

  if (isPreviewNav) {
    return children;
  }

  if (loadingAuth) {
    return (
      <div className="container" style={{ maxWidth: "1120px" }}>
        <Spinner minHeight="50vh" title="Carregando..." />
      </div>
    );
  }

  if (!isAuthenticated) {
    // Bloqueia conteúdo protegido enquanto não logado
    return null;
  }

  return children;
};

export default PrivateRoute;